var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"book-icon-library-container"},[_c('div',{staticClass:"book-icon-library"},_vm._l((_vm.numBooks),function(index){return _c('BookIcon',{attrs:{"name":_vm.bookList[(index - 1) % _vm.bookList.length].name,"rotation":_vm.bookList[(index - 1) % _vm.bookList.length].rotation}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }